import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import { Store } from 'store/storeTypes';
import PbiFilterMonths from './PbiFilterMonths';
import { setActiveDate } from 'actions/reportFilterActions';
import { activeReportSelector } from 'reducers/reports/filterDataReducer';
type OwnProps = {
  mode?: string;
  isMobile?: boolean;
  closeCalendarModal?: () => void;
};
const mapStateToProps = (state: Store) => {
  const { selectedDate } = state.reports.filterState[state.ui.selectedSystemGroup]!;
  const { startDate, endDate } = state.reports.filterData[state.ui.selectedSystemGroup]!;
  return {
    selectedDate,
    startDate,
    endDate,
    activeReport: activeReportSelector(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({ setActiveDate }, dispatch);

export type PbiFilterMonthsProps = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  OwnProps;

export default connect(mapStateToProps, mapDispatchToProps)(PbiFilterMonths);
